import { defaultsTo } from '../../utils/utilsGlobal';
import { gql, insertGraphQLFragments } from '../GraphQLClient';


export const fragmentFileBasic = gql`
  fragment fragmentFileBasic on File {
    id
    url
    thumbnails {
      url
    }
  }
`;


export const fragmentFileFull = insertGraphQLFragments(gql`
  fragment fragmentFileFull on File {
    ...fragmentFileBasic
    name
    height
    width
    duration
    bytesSize
    contentType
    isSticker
    status
  }
`, { fragmentFileBasic });


export function serializeFileUrl(url){
  const uploadsUrlPrefix = process.env.API_URL.replace(/\/$/, '') + '/';
  if (url) {
    return /^uploads/i.test(url) ? uploadsUrlPrefix + url : url;
  }
  else {
    return '';
  }
}


export function serializeFileBasic(data){
  const { id, url, thumbnails } = data || {};
  const firstThumbnailUrl = thumbnails?.[0]?.url;
  const firstThumbnail = {
    url: serializeFileUrl(firstThumbnailUrl || url),
  };
  return {
    id: id || null,
    url: serializeFileUrl(url),
    thumbnails: [ firstThumbnail ],
  };
}


export function serializeFileFull(data){
  const serializedFileBasic = serializeFileBasic(data);
  const serializedData = defaultsTo(data, {
    name: '',
    bytesSize: 0,
    height: 0,
    width: 0,
    duration: 0,
    contentType: '',
    isSticker: false,
    status: null,
  });
  return {
    ...serializedFileBasic,
    ...serializedData,
  };
}
